"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PencilIcon = function PencilIcon(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 32 32"
  }, props), _react.default.createElement("path", {
    d: "M30.975 5.525l.002.033-4.535-4.535.033.002C25.842.392 24.967 0 24 0s-1.841.392-2.475 1.025L3.439 19.075c-.179.179-.31.401-.38.644L.06 30.083a1.5 1.5 0 0 0 1.857 1.856l10.365-2.999c.243-.07.465-.201.643-.38l18.05-18.086C31.608 9.841 32 8.966 32 7.999s-.392-1.841-1.025-2.475zM3.698 28.302l1.792-6.191 4.399 4.399-6.191 1.792zM28.856 8.387L12.432 24.811l-5.243-5.243L23.613 3.144c.125-.125.275-.144.354-.144s.228.019.354.144l4.535 4.535a.506.506 0 0 1 0 .707z"
  }));
};

PencilIcon.propTypes = {
  size: _propTypes.number
};
PencilIcon.defaultProps = {
  size: 40
};
var _default = PencilIcon;
exports.default = _default;